<template>
  <div ref="datePickerContainer">
    <PVDatePicker
      ref="datePicker"
      :input-style="componentStyle"
      @value-change="saveInput"
    />
  </div>
</template>

<script lang="ts" setup>
  import { ref, onMounted, nextTick } from 'vue';
  import { DatePickerValueChangeEvent } from '@/interfaces';
  import { isSingleDateEvent } from '@/utils';
  import { CSSProperties } from 'vue';
  import PVDatePicker from 'primevue/datepicker';

  const props = defineProps<{
    close: Function;
    model: object;
    rowIndex: number;
    save: Function;
  }>();

  const componentStyle = ref<CSSProperties>({
    position: 'fixed',
    top: '0px',
    left: '0px',
  });

  function saveInput(date: DatePickerValueChangeEvent): void {
    if (!isSingleDateEvent(date)) return;
    const transformedDate = date.toLocaleDateString('en-US');
    props.save(transformedDate);
  }

  const datePickerContainer = ref<HTMLElement | null>(null);
  function positionDateInput(): void {
    nextTick(() => {
      const element = datePickerContainer.value as HTMLElement;
      const containingCell = (
        (element as HTMLElement)?.parentNode?.parentNode as HTMLElement
      )?.getBoundingClientRect();

      const rect = element.getBoundingClientRect();

      const topOffset = `${rect.top}px`;
      const leftOffset = `${rect.left}px`;
      const dateInputWidth = `${containingCell.width}px`;
      const dateInputHeigth = `${containingCell.height}px`;

      componentStyle.value.top = topOffset;
      componentStyle.value.left = leftOffset;
      componentStyle.value.width = dateInputWidth;
      componentStyle.value.minWidth = dateInputWidth;
      componentStyle.value.height = dateInputHeigth;
    });
  }

  onMounted(() => {
    positionDateInput();
  });
</script>
